import {
  DetailsList,
  Link,
  Panel,
  PanelType,
  SearchBox,
  SelectionMode,
} from "@fluentui/react";
import {
  getWorkOrders,
  IPagedCollection,
  IWorkOrder,
} from "../../services/assetServices";
import { useEffect, useState } from "react";
import { useSetAtom } from "jotai";
import { errorMessageAtom, isInProgressAtom } from "../../atoms/messageBarAtoms";

export interface IWorkOrderSelectorProps {
  isOpen: boolean;
  hideWorkOrderSelector: any;
  onWorkOrderSelected: (id: number) => void;
}

const WorkOrderSelector = (props: IWorkOrderSelectorProps) => {
  const [workOrders, setWorkOrders] = useState<IWorkOrder[]>([]);

  const setErrorMessage = useSetAtom(errorMessageAtom);
  const setIsInProgress = useSetAtom(isInProgressAtom);

  const fetchData = async () => {
    const abortController = new AbortController();
    setIsInProgress(true);
    try {
      const workOrders: IPagedCollection<IWorkOrder> = await getWorkOrders(abortController, 10, 1);
      setWorkOrders(workOrders.items);
    } catch (error: any) {
      setErrorMessage(error.message);
    } finally {
      setIsInProgress(false);
    }
    return () => {
      abortController.abort();
    };
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Panel
      isLightDismiss
      isOpen={props.isOpen}
      onDismiss={props.hideWorkOrderSelector}
      closeButtonAriaLabel="Close"
      type={PanelType.medium}
      headerText="Pick work order"
    >
      <SearchBox
        placeholder="Search work order"
        onSearch={(newValue) => {
          const abortController = new AbortController();
          getWorkOrders(abortController, 10, 1, newValue).then(
            (workOrders: IPagedCollection<IWorkOrder>) => {
              setWorkOrders(workOrders.items);
            }
          );
        }}
        onClear={() => setWorkOrders([])}
      />
      <DetailsList
        columns={[
          {
            key: "Id",
            name: "Id",
            fieldName: "id",
            minWidth: 50,
            maxWidth: 50,
            isResizable: true,
            onRender: (item) => (
              <Link
                key={item.id}
                onClick={() => {
                  props.onWorkOrderSelected(item?.id);
                }}
              >
                {item.id}
              </Link>
            ),
          },
          {
            key: "Code",
            name: "Code",
            fieldName: "code",
            minWidth: 75,
            maxWidth: 100,
            isResizable: true,
          },
          {
            key: "Status",
            name: "Status",
            fieldName: "status",
            minWidth: 75,
            maxWidth: 100,
            isResizable: true,
          },
          {
            key: "StatusDescription",
            name: "StatusDescription",
            fieldName: "statusDescription",
            minWidth: 150,
            maxWidth: 175,
            isResizable: true,
          },
        ]}
        compact={true}
        items={workOrders}
        selectionMode={SelectionMode.none}
      />
    </Panel>
  );
};

export default WorkOrderSelector;